import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material';
import { environment } from 'environments/environment';

interface Porcentaje {
  id?: number;
  tipo: 'aporte' | 'contribucion';  // Tipo de porcentaje
  porcentaje: number;                // Valor del porcentaje (ej: 0.0255 = 2.55%)
  titulo: string;
  descripcion: string;
  anio: number;                      // Año al que aplica
}

@Component({
  selector: 'app-porcentajes',
  templateUrl: './porcentajes.component.html',
  styleUrls: ['./porcentajes.component.css']
})
export class PorcentajesComponent implements OnInit {

  porcentajes: Porcentaje[] = [];
  loading: boolean = false;
  editMode: boolean = false;

  // Formulario
  porcentajeForm: Porcentaje = {
    tipo: 'aporte',
    porcentaje: 0.0255,      // 2.55% por defecto
    titulo: '',
    descripcion: '',
    anio: new Date().getFullYear()
  };

  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.cargarPorcentajes();
  }

  cargarPorcentajes() {
    this.loading = true;
    this.http.get<Porcentaje[]>(`${environment.backendUrl}/api/porcentajes`)
      .subscribe(
        data => {
          this.porcentajes = data;
          this.loading = false;
        },
        error => {
          console.error('Error al cargar porcentajes:', error);
          this.snackBar.open('Error al cargar los porcentajes', 'Cerrar', {
            duration: 3000
          });
          this.loading = false;
        }
      );
  }

  guardarPorcentaje() {
    if (!this.validarFormulario()) {
      return;
    }

    this.loading = true;

    if (this.editMode && this.porcentajeForm.id) {
      // Actualizar
      this.http.put(`${environment.backendUrl}/api/porcentajes/${this.porcentajeForm.id}`, this.porcentajeForm)
        .subscribe(
          () => {
            this.snackBar.open('Porcentaje actualizado correctamente', 'Cerrar', {
              duration: 3000
            });
            this.cargarPorcentajes();
            this.limpiarFormulario();
          },
          error => {
            console.error('Error al actualizar:', error);
            this.snackBar.open('Error al actualizar el porcentaje', 'Cerrar', {
              duration: 3000
            });
            this.loading = false;
          }
        );
    } else {
      // Crear nuevo
      this.http.post(`${environment.backendUrl}/api/porcentajes`, this.porcentajeForm)
        .subscribe(
          () => {
            this.snackBar.open('Porcentaje creado correctamente', 'Cerrar', {
              duration: 3000
            });
            this.cargarPorcentajes();
            this.limpiarFormulario();
          },
          error => {
            console.error('Error al crear:', error);
            this.snackBar.open('Error al crear el porcentaje', 'Cerrar', {
              duration: 3000
            });
            this.loading = false;
          }
        );
    }
  }

  editarPorcentaje(porcentaje: Porcentaje) {
    this.editMode = true;
    this.porcentajeForm = { ...porcentaje };
    window.scrollTo(0, 0);
  }

  eliminarPorcentaje(id: number) {
    if (!confirm('¿Está seguro de eliminar este porcentaje?')) {
      return;
    }

    this.loading = true;
    this.http.delete(`${environment.backendUrl}/api/porcentajes/${id}`)
      .subscribe(
        () => {
          this.snackBar.open('Porcentaje eliminado correctamente', 'Cerrar', {
            duration: 3000
          });
          this.cargarPorcentajes();
        },
        error => {
          console.error('Error al eliminar:', error);
          this.snackBar.open('Error al eliminar el porcentaje', 'Cerrar', {
            duration: 3000
          });
          this.loading = false;
        }
      );
  }

  limpiarFormulario() {
    this.editMode = false;
    this.porcentajeForm = {
      tipo: 'aporte',
      porcentaje: 0.0255,
      titulo: '',
      descripcion: '',
      anio: new Date().getFullYear()
    };
  }

  validarFormulario(): boolean {
    if (!this.porcentajeForm.titulo || this.porcentajeForm.titulo.trim() === '') {
      this.snackBar.open('El título es requerido', 'Cerrar', {
        duration: 3000
      });
      return false;
    }

    if (!this.porcentajeForm.tipo) {
      this.snackBar.open('El tipo es requerido', 'Cerrar', {
        duration: 3000
      });
      return false;
    }

    if (this.porcentajeForm.porcentaje === null || this.porcentajeForm.porcentaje === undefined) {
      this.snackBar.open('El porcentaje es requerido', 'Cerrar', {
        duration: 3000
      });
      return false;
    }

    if (this.porcentajeForm.porcentaje < 0 || this.porcentajeForm.porcentaje > 9.9999) {
      this.snackBar.open('El porcentaje debe estar entre 0 y 9.9999', 'Cerrar', {
        duration: 3000
      });
      return false;
    }

    if (!this.porcentajeForm.anio || this.porcentajeForm.anio < 2000 || this.porcentajeForm.anio > 2100) {
      this.snackBar.open('El año debe estar entre 2000 y 2100', 'Cerrar', {
        duration: 3000
      });
      return false;
    }

    return true;
  }

  formatearPorcentaje(porcentaje: number): string {
    return (porcentaje * 100).toFixed(2) + '%';
  }

  getTipoLabel(tipo: string): string {
    return tipo === 'aporte' ? 'Aporte' : 'Contribución';
  }

  getTipoBadgeClass(tipo: string): string {
    return tipo === 'aporte' ? 'badge-primary' : 'badge-success';
  }

}
